const quickLinks = [
  { id: 'updates', label: '今日更新速递' },
  { id: 'hot', label: '热门新片精选' },
  { id: 'series', label: '全集与追更专区' },
  { id: 'rank', label: '站内热度榜' },
];

const moreLinks = [
  { id: 'categories', label: '内容分类导航' },
  { id: 'guide', label: '追更指南' },
  { id: 'faq', label: '常见问题' },
  { id: 'about', label: '资源整理说明' },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-950 text-background-100 px-4 md:px-8 pt-12 md:pt-16 pb-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3">
            <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-movie-2-line text-xl" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">蓝莓视频</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-200 max-w-md">
            蓝莓视频资源更新速递页，集中呈现热门新片、全集内容与每日更新动态，帮助你在一页之内找到近期值得看的条目并安排追更节奏。
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {['电影', '剧集', '动漫', '综艺', '纪实'].map((tag) => (
              <span key={tag} className="text-xs px-3 py-1 rounded-full bg-background-50/10 text-background-100">
                {tag}
              </span>
            ))}
          </div>
        </div>

        <nav aria-label="页脚快速导航">
          <h3 className="font-heading text-sm font-bold text-accent-400">快速导航</h3>
          <ul className="mt-4 space-y-3">
            {quickLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="页脚更多内容">
          <h3 className="font-heading text-sm font-bold text-accent-400">更多内容</h3>
          <ul className="mt-4 space-y-3">
            {moreLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="text-xs text-background-300">
          © 2026 蓝莓视频资源速递 · 页面内容为浏览整理的示例信息，具体以内容方实际发布为准。
        </p>
        <a href="#top" className="text-xs text-background-200 hover:text-background-50 transition-colors cursor-pointer">
          回到页面顶部
        </a>
      </div>
    </footer>
  );
}